module.exports = __webpack_public_path__ + "static/media/Character.f0953482.png";